import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

type AlertDialogProps = {
  title: string;
  description: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const AlertDialog = ({ title, description, open, onClose, onConfirm }: AlertDialogProps) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="default">
            Annuler
          </Button>
          <Button onClick={onConfirm} color="primary" autoFocus>
            Continuer
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialog;
